import { default as React, ReactNode } from "react";
import styles from "./CardTrio.module.scss";
import { CardListLayout } from "../../model/common";
import ChevronRightIcon from "../../icons/ChevronRightIcon";

export interface CardTrioProps {
  sequence?: boolean;
  children: ReactNode;
  layout?: CardListLayout;
}

const CardTrio = ({ sequence = false, children, layout }: CardTrioProps) => {
  return (
    <div className={`${styles.row} ${layout === "stretch" && styles.stretch}`}>
      {React.Children.map(children, (c, index) => (
        <div className={styles.col}>
          {c}
          {sequence && index + 1 !== React.Children.count(children) && (
            <ChevronRightIcon className={styles.icon} />
          )}
        </div>
      ))}
    </div>
  );
};

export default CardTrio;
